<template>
  <div>
    <el-button :size="isPredictEvent === true ? 'small' : 'mini'" :v-show="troubleShootingBtnFlag" :disabled="!disabledFlag" type="primary" @click="clickEventTicketButton">
      장애조치추천
    </el-button>
    <w-recommend-handling-trouble-popup :eventHistSeqNumbers="eventHistSeqNumbers" :is-predict-event="isPredictEvent" ref="recommendPopup"></w-recommend-handling-trouble-popup>
  </div>
</template>

<script>
import WRecommendHandlingTroublePopup from './popup/RecommendHandlingTroublePopup';

export default {
  name: 'WRecommendHandlingTroubleButton',
  components: {
    WRecommendHandlingTroublePopup,
  },
  props: {
    eventHistSeqNumbers: {
      type: Array,
    },
    isPredictEvent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    disabledFlag() {
      return (this.eventHistSeqNumbers.length > 0);
    },
  },
  data() {
    return {
      troubleShootingBtnFlag: false,
    };
  },
  methods: {
    clickEventTicketButton() {
      this.troubleShootingBtnFlag = true;
      this.$refs.recommendPopup.open();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/components/RecommendHandlingTroubleButton.vue